export default {
    membership_management: {
        no_membership_number: 'Completa il tuo primo investimento per diventare membro.',
        membership_number: 'Numero di membro',
        download_document: 'Scarica documento di appartenenza',
        send_document: 'Ricevi modulo per posta',
        send_document_requested: 'Invio documento richiesto',
        send_document_sent: 'Documento è stato inviato',
        document_label: 'Documento di appartenenza',
        order_certificates: 'Ordina Certificato',
    },
    account_dropdown_log_out: 'Esci',
    account_dropdown_company_account: 'Account aziendale',
    account_dropdown_tooltip_account: 'Account investitore',
    account_dropdown_tooltip_fill_account_data: 'Completa i tuoi dati di investitore',
    account_dropdown_tooltip_orders: 'Ordini',
    account_dropdown_tooltip_wallets: 'Portafoglio',
    personal_account: 'Panoramica account',
    welcome: 'Benvenuto',
    header_new_investor: 'Nuovo investitore?',
    header_register: 'Registrati',
    header_sign_in: 'Accedi',
    header_unfinished_investment_process: 'Hai un ordine in corso',
    email_verification_already_verified: 'Il tuo indirizzo email è già stato verificato',
    email_verification_email_pending_missmatch:
        'L`indirizzo email non ha potuto essere verificato. Nel frattempo è stata avviata un`altra verifica email. Per favore riprova.',
    email_verification_expired_link: 'Il link di conferma è scaduto.',
    email_verification_verified: 'Il tuo indirizzo email è stato modificato con successo!',
    create_company_profile_question: 'Vuoi creare un account aziendale per il tuo account?',
    create_company_profile: 'Crea account aziendale',
    language_switcher_select_language: 'Seleziona lingua',
    discard: 'Annulla',
    header: {
        sign_in: 'Accedi',
        register: 'Registrati',
        new_to_invest: 'Nuovo investitore?',
    },
    kyc_provider: {
        idnow: 'IDNow',
        signteq: 'Signteq',
    },
    pay_via_eth: 'Paga via ETH',
    gas_limit: 'Prezzo Gas',
    address_to_send_eth: 'Indirizzo destinatario per ETH',
    pay_via_eth_desc:
        'Pagamento via ETH-descrizione: Se utilizzi il bonifico bancario come opzione di pagamento, verrà applicata una commissione aggiuntiva che dipende dall`importo totale del tuo investimento. Commissione aggiuntiva per il trasferimento del tuo investimento.',
    portfolio_size: 'Dimensione del portafoglio',
    view_details: 'Visualizza dettagli',
    date: 'Data',
    time: 'Ora',
    total: 'Totale',
    investment: 'Investimento',
    investment_amount: 'Importo investimento',
    support_amount: 'Importo supporto',
    order_status_canceled: 'Annullato',
    order_status_pending: 'In attesa',
    order_status_paid: 'Pagato',
    order_status_approved: 'Approvato',
    order_status_covered: 'Coperto',
    order_status_accepted: 'Accettato',
    my_orders_side: 'I miei ordini',
    no_order: 'Nessun ordine',
    order_voucher_amount: 'Importo dal voucher',
    order_discount_voucher_amount: 'Importo dal codice sconto',
    order_wallet_amount: 'Importo dal portafoglio',
    success: '',
    error: '',
    copy: '',
    save: '',
    copy_to_clipboard: '',
    copied_to_clipboard: '',
    errors: {
        validation_error: '',
        general_error: '',
    },
    terms_link: '',
    privacy_link: '',
    admin_email: '',
    contact_support: '',
    investment_process: {
        accept_savings_plan: 'Piano di risparmio',
        accept_gift_membership: 'Regalo di appartenenza',
        visit_faq_url: 'Per maggiori informazioni clicca qui',
        emission_agio_text: '',
        emission_disagio_text: '',
        sign_digitally: '',
        signature: 'Firma',
        confirm_signature: 'Conferma firma',
        reset_verification_header: 'Dobbiamo reimpostare la tua verifica',
        // prettier-ignore
        reset_verification_body:
            'Poiché ti sei verificato tramite il nostro precedente partner IDnow, è necessaria una nuova verifica tramite Signteq prima di poter investire.<br><br>' +
            'Per favore contatta il team di supporto via email a <a href="mailto:support{\'@\'}conda-capital.com">support{\'@\'}conda-capital.com</a> per reimpostare il processo di verifica.',
        signature_legal_notice: '',
        signature_legal_notice_title: '',
        nyala_vault: '',
        or: '',
        download_signature_document: '',
        law_requirements: '',
        summary: '',
        payment: '',
        contract_period: '',
        issuer: 'Emittente',
        minimum_investment: '',
        steps: '',
        next: '',
        back: '',
        time_left: '',
        to_the_landing_page: '',
        thank_you_for_you_investment: '',
        pay_via_bank_transfer_header: '',
        pay_via_bank_transfer_description: '',
        go_to_my_orders: '',
        please_accept_all_documents: '',
        please_accept_all_disclaimers: '',
        please_accept_all_warnings: '',
        wallet_retrievable_balance: 'Importo disponibile sul portafoglio',
        voucher_available_balance: 'Importo disponibile sul voucher',
        update_wallet_amount: 'Aggiorna saldo portafoglio',
        apply_wallet_amount: 'Attiva saldo portafoglio',
        update_voucher_amount: 'Aggiorna saldo voucher',
        apply_voucher_amount: 'Attiva saldo voucher',
        discount_code_applied_successfully: 'Codice sconto attivato con successo',
        discount_code_higher_than_amount:
            'Il codice sconto non può essere applicato poiché lo sconto è superiore all`importo rimanente.',
        available: 'disponibile',
        discount_code: 'Codice sconto',
        apply_discount_button: 'Attiva',
        activate_balance: '',
        public_name_consent: '',
        disclaimers: '',
        understand_all_risks: '',
        contract_documents: '',
        accept_all_documents: '',
        accept_all_warnings: '',
        investment_warnings: '',
        investment_warnings_description: '',
        pre_contractual_cooling_off_period: '',
        pre_contractual_cooling_off_period_description: '',
        incentives: '',
        incentive: '',
        selected_incentive: '',
        select_incentive: '',
        which_contract_type: '',
        voucher_title: '',
        voucher_description: '',
        cash_title: '',
        cash_description: '',
        enter_investment_amount: '',
        min_amount: '',
        max_amount: '',
        step_level: '',
        invest: '',
        enter_investment_pieces: '',
        emission_pieces_to_amount: '',
        emission_amount_to_pieces: '',
        investment_summary: '',
        investment_amount: '',
        wallet_amount: '',
        wallet_amount_description:
            'Seleziona l`importo che desideri coprire con il saldo esistente del tuo portafoglio',
        voucher_amount: '',
        voucher_amount_description: 'Seleziona il voucher desiderato e l`importo che desideri attivare.',
        expires_at: 'Scade il',
        contract_type: '',
        amount_to_pay: '',
        registration_number: '',
        address: '',
        invest_as_natural_profile: '',
        invest_as_legal_profile: '',
        invest_in: '',
        create_order: '',
        payment_account_holder_default: '',
        pay_via_credit_card_header: '',
        pay_via_credit_card_description: '',
        pay_via_credit_card_button: '',
        verification_outstanding: '',
        verification_outstanding_description: '',
        verify_button: '',
        broker: '',
        broker_id: '',
        please_provide_broker_id: '',
        please_confirm: '',
        please_confirm_your_details: '',
        please_fill_required_fields: '',
        note: 'nota',
        ecsp: {
            not_enough_experience_title: '',
            not_enough_experience_description: '',
            not_enough_risk_acknowledgements_title: '',
            not_enough_risk_acknowledgements_description: '',
            investment_too_high_title: '',
            investment_too_high_description: '',
        },
        altfg: {
            investment_process_altfg_notice: '',
            investment_process_altfg_choice_notice: '',
            investment_process_altfg_professional_investor: '',
            investment_process_altfg_legal_entity: '',
            investment_process_altfg_maximum_net_income: '',
            investment_process_altfg_maximum_assets: '',
        },
        vermanlg: {
            vib_investor_from_germany: '',
            investments_information_sheet: '',
            vib_current_location: '',
            vib_date: '',
            vib_email: '',
            vib_first_name: '',
            vib_last_name: '',
            vib_place_of_birth: '',
            vib_date_of_birth: '',
            vib_id_card_passport_number: '',
            issuing_authority: '',
            vib_address: '',
            vib_postal_code: '',
            vib_city: '',
            vib_state: '',
            vib_tax_number: '',
            vib_investment_information: '',
            vib_investment_under_1000: '',
            vib_investment_financial_assets_over_10000: '',
            vib_investment_income_over_1k: '',
            vib_investment_income_over_10k: '',
            vib_investment_limit_part_1: '',
            vib_investment_limit_part_2: '',
            vermanlg_confirm_section_note: '',
            vermanlg_right_of_withdrawal: '',
            vermanlg_right_of_withdrawal_disclaimer: '',
            vermanlg_consequences_of_revocation: '',
            vermanlg_consequences_of_revocation_disclaimer: '',
        },
        stock_price: 'Prezzo per quota',
    },
    forms: {
        select_option: '',
        radio_no: '',
        radio_yes: '',
        radio_male: '',
        radio_female: '',
        day: '',
        month: '',
        year: '',
        dd: '',
        mm: '',
        yyyy: '',
    },
    account: {
        investor_account: '',
        my_profile: '',
        first_name: '',
        last_name: '',
        save: '',
        date_of_birth: '',
        nationality: '',
        address: '',
        postal_code: '',
        city: '',
        same_as_residential: '',
        country_of_birth: '',
        city_of_birth: '',
        // prettier-ignore
        esac_locked_account_info:
            'Per modificare o aggiornare le informazioni e i documenti del profilo o KYC, contatta il team ESAC via email a platform{\'@\'}superangels.club',
        phone_number: '',
        iban: '',
        bic: '',
        social_security_number: '',
        tax_number: '',
        mobile_number: '',
        current_email: '',
        email_pending: '',
        new_email: '',
        email_address: '',
        country: '',
        state: '',
        gender: '',
        gender_placeholder: '',
        pep: '',
        pep_past: '',
        pep_position: '',
        saved_successfully_title: '',
        saved_successfully_message: '',
        saved_kyc_successfully_message: '',
        average_investment_transaction_amount: '',
        average_investment_transactions_per_year: '',
        investment_transactions: '',

        experience_share: '',
        experience_bond: '',
        experience_participation_paper: '',
        experience_crypto_currency: '',
        experience_unsecured_junior_debt: '',
        knowledge_share: '',
        knowledge_bond: '',
        knowledge_participation_paper: '',
        knowledge_crypto_currency: '',
        knowledge_unsecured_junior_debt: '',

        experience_with_securities: '',
        experience_without_advice: '',
        experience_with_asset_management: '',
        experience_with_investment_advice: '',

        bonds: '',
        stocks: '',
        market_funds: '',
        investment_funds: '',
        experience_investment_forms: '',
        current_occupation: '',
        highest_educational_attainment: '',
        default_language: 'Lingua predefinita',
    },
    portfolio: {
        investments_total: '',
        open_investments: '',
        my_investments: '',
        no_investments_to_show: '',
        orders: {
            order_status: '',
            order_status_active: '',
            order_status_completed: '',
            order_status_canceled: '',
            order_status_pending: '',
            order_status_paid: '',
            order_status_approved: '',
            order_status_covered: '',
            order_status_accepted: '',
        },
    },
    investment_targets: {
        investment_objectives: 'I tuoi obiettivi di investimento',
        // prettier-ignore
        legal_investment_objectives: 'Obiettivi di investimento dell\'entità',
        security_coverage: 'Piano pensionistico',
        security_coverage_or_pension_plan:
            'Copertura di sicurezza del pagamento di fine rapporto o piano pensionistico',
        pension_provision: 'Provvista pensionistica',
        retention_of_assets: 'Conservazione degli asset',
        distribution_of_assets: 'Distribuzione degli asset',
        capital_gain: 'Plusvalenza',
        investment_horizon: 'Il tuo orizzonte di investimento',
        // prettier-ignore
        legal_investment_horizon: 'Orizzonte di investimento dell\'entità',
        investment_frequency:
            'Frequenza dei tuoi investimenti in asset alternativi (inclusi Venture Capital e Private Equity)',
        // prettier-ignore
        legal_investment_frequency:
            'Frequenza degli investimenti dell\'entità in asset alternativi (inclusi Venture Capital e Private Equity):',
    },
    financial_conditions: {
        financial_assets: 'Asset finanziari (in EUR)',
        annual_operating_result: 'Reddito annuale (in EUR)',
        dept_capital: 'Capitale di debito (in EUR)',
        properties: 'Proprietà immobiliare',
        source_of_funds: 'Fonte dei fondi (questa è l`origine dei fondi specifici che investirai)',
        dividends_or_profits: 'Dividendi o profitti da investimenti',
        lottery_gambling: 'Lotteria/gioco d`azzardo',
        divorce: 'Divorzio',
        maturity_or_surrender: 'Scadenza o riscatto della polizza assicurativa sulla vita',
        gift: 'Regalo',
        inheritance: 'Eredità',
        insurance_claims: 'Richieste di risarcimento assicurativo',
        sale_of_property: 'Vendita di proprietà',
        savings: 'Risparmi',
        loan: 'Prestito',
        other: 'Altro',
        industry: 'Settore della tua principale attività commerciale e/o occupazione:',
        // prettier-ignore
        business_industry: 'Settore della principale attività commerciale dell\'entità:',
        dividends_or_profits_legal: 'Dividendi o profitti da partecipazioni/investimenti/asset',
        retained_earnings: 'Utili trattenuti',
    },
    fatca_declaration: {
        cannot_continue: 'Sfortunatamente, non puoi completare il processo KYC online.',
        financial_institutions_under_fatca:
            'Classificazione FATCA della società: L`entità è un`istituzione finanziaria (FI) ai sensi della FATCA?',
        // prettier-ignore
        contact_support: 'Per favore contatta Venionaire a platform{\'@\'}superangels.club.',
        us_citizen_or_resident: 'Sei un cittadino statunitense e/o residente negli Stati Uniti a fini fiscali?',
        non_financial_entity_reason:
            'Seleziona una delle seguenti categorie per indicare quale tipo di NFE è l`investitore (Entità legale)',
        financial_institution_category:
            'Istituzioni finanziarie ai sensi della FATCA: Seleziona una delle seguenti categorie:',
        us_entity: 'L`entità è una Persona statunitense ai sensi delle normative FATCA?',
        provide_giin: 'Puoi fornire il GIIN del titolare del registro ottenuto per scopi FATCA',
        no_giin_reason:
            'Se la società è un`istituzione finanziaria ma non può emettere un GIIN, seleziona uno dei seguenti motivi:',
        giin: 'Fornisci il GIIN dell`Entità ottenuto per scopi FATCA:',
        giin_sponsor_name: 'Nome dello Sponsor',
        giin_sponsor: 'GIIN dello Sponsor',
    },
    crs_classification: {
        company_classification: 'Classificazione CRS della società:',
        stock_exchange_name:
            'Fornisci il nome della borsa valori stabilita dove le azioni della società sono regolarmente negoziate:',
        affiliate_stock_exchange_name:
            'Oppure Se sei un affiliato di una società regolarmente negoziata su una borsa valori stabilita, fornisci il nome della borsa valori stabilita e quella società:',
    },
    country_tax_residencies: {
        add_another_tax_residence: 'Aggiungi un`altra residenza fiscale',
        cant_obtain_tin: 'Non posso ottenere un TIN',
        tax_situation: 'La tua situazione fiscale',
        tax_residency: 'Residenza fiscale',
        capital_gains: 'Esenzione dall`imposta sulle plusvalenze (KESt)',
        foreign_assets_ownership: 'Proprietà di asset esteri',
        foreign_assets: 'Asset esteri',
        capital_gains_legal: 'Esenzione dall`imposta sulle plusvalenze (KESt)',
        corporate_tax_exemption: 'Esenzione dall`imposta sulle società (KÖSt)',
        group_taxation: 'Tassazione di gruppo',
    },
    legal_acknowledgements: {
        risks_acknowledgement:
            'Io/noi riconosciamo che Venionaire Ventures S.à r.l. ("VV") non accetterà una domanda per l\'acquisto di quote di fondi in nessun caso se non vengono fornite informazioni sulla disposizione al rischio. Inoltre, io/noi riconosciamo che, oltre ai rischi elencati, possono verificarsi fluttuazioni di valore dovute a cambiamenti valutari (inclusa l\'inflazione).',
        // prettier-ignore
        anti_money_laundering:
            'In conformità con la legge modificata sul riciclaggio di denaro e il finanziamento del terrorismo del 12 novembre 2004, io/noi dichiariamo che l\'UBO/i rivelato/i è/sono il/i beneficiario/i effettivo/i dell\'Investitore e ci impegniamo a informare il revisore di VV di qualsiasi modifica nella partecipazione dell\'Investitore, nei diritti di voto o nel/i beneficiario/i effettivo/i. Io/noi dichiariamo anche che l\'origine dei fondi e dei titoli utilizzati per effettuare le operazioni dell\'Investitore non contravviene a tale legge. Io/noi dichiariamo infine che l\'uso previsto degli asset derivanti da queste operazioni non contravverrà a tale legge.',
        authorised_signatory:
            'Io/noi certifico/amo che io/noi sono i firmatari autorizzati dell`Investitore e riconosco/amo che, ai sensi dell`articolo 5 della legge CRS del Lussemburgo, è obbligatorio rispondere alle domande relative alle informazioni rivelate riguardo all`autocertificazione fiscale.',
        tax_authorities:
            'In particolare, io/noi riconosciamo e accettiamo che le informazioni rivelate possano essere segnalate alle autorità fiscali in Lussemburgo o altri delegati autorizzati ai sensi della legge lussemburghese in conformità con le informazioni richieste in relazione ai conti finanziari (vedi Allegato I, Sezione I della Legge "Loi du 18 décembre 2015 relative à la Norme Commune de Déclaration (NCD)", qui di seguito "Legge CRS del Lussemburgo") in relazione all\'Investitore o al/i suo/i beneficiario/i effettivo/i e qualsiasi registro segnalabile. Inoltre, io/noi riconosciamo e accettiamo che le informazioni rivelate possano essere scambiate con le autorità fiscali del/i paese/i in cui io/noi e/o l\'Investitore ha/hanno stabilito una residenza fiscale in conformità con gli accordi intergovernativi di scambio di dati fiscali.',
        intergovernmental_tax_exchange:
            'Io/noi autorizziamo VV a inoltrare/scambiare tutte le informazioni rivelate, nonché le informazioni necessarie per la segnalazione ai sensi degli accordi intergovernativi di scambio di dati fiscali, come descritto sopra, con le competenti autorità fiscali del paese o dei paesi.',
        notify_about_changes:
            'Io/noi ci impegniamo a notificare a VV entro 30 giorni qualsiasi modifica che influisca sull`autocertificazione e qualsiasi modifica che influisca sulle informazioni fornite e a fornire a VV una corrispondente autocertificazione aggiornata senza indugio e senza richiesta. Io/noi avranno accesso, su richiesta, ai dati che mi/ci riguardano/l`Investitore/gli UBO che saranno rivelati alle autorità fiscali lussemburghesi e potranno rettificare i dati personali. I dati raccolti non saranno conservati più a lungo del necessario per gli scopi della legge CRS del Lussemburgo.',
        information_correct_and_complete:
            'Io/noi dichiariamo che tutte le informazioni fornite da me/noi sono corrette e complete secondo la mia/nostra migliore conoscenza e convinzione.',
    },
    acknowledgements: {
        check_all: 'Seleziona tutto',
        currency_change_risk:
            'Io/noi riconosciamo che Venionaire Ventures S.à r.l. ("VV") non accetterà una domanda per l\'acquisto di quote di fondi in nessun caso se non vengono fornite informazioni sulla disposizione al rischio. Inoltre, io/noi riconosciamo che, oltre ai rischi elencati, possono verificarsi fluttuazioni di valore dovute a cambiamenti valutari (inclusa l\'inflazione).',
        own_account:
            'Io/noi certifico/amo che io/noi sono i firmatari autorizzati dell`Investitore e riconosco/amo che, ai sensi dell`articolo 5 della legge CRS del Lussemburgo, è obbligatorio rispondere alle domande relative alle informazioni rivelate riguardo all`autocertificazione fiscale.',
        // prettier-ignore
        anti_money_laundering:
            'In conformità con la legge modificata sul riciclaggio di denaro e il finanziamento del terrorismo del 12 novembre 2004, io/noi dichiariamo che l\'UBO/i rivelato/i è/sono il/i beneficiario/i effettivo/i dell\'Investitore e ci impegniamo a informare il revisore di VV di qualsiasi modifica nella partecipazione dell\'Investitore, nei diritti di voto o nel/i beneficiario/i effettivo/i. Io/noi dichiariamo anche che l\'origine dei fondi e dei titoli utilizzati per effettuare le operazioni dell\'Investitore non contravviene a tale legge. Io/noi dichiariamo infine che l\'uso previsto degli asset derivanti da queste operazioni non contravverrà a tale legge.',
        self_certification_form:
            'In particolare, io/noi riconosciamo e accettiamo che le informazioni rivelate possano essere segnalate alle autorità fiscali in Lussemburgo o altri delegati autorizzati ai sensi della legge lussemburghese in conformità con le informazioni richieste in relazione ai conti finanziari (vedi Allegato I, Sezione I della Legge "Loi du 18 décembre 2015 relative à la Norme Commune de Déclaration (NCD)", qui di seguito "Legge CRS del Lussemburgo") in relazione all\'Investitore o al/i suo/i beneficiario/i effettivo/i e qualsiasi registro segnalabile. Inoltre, io/noi riconosciamo e accettiamo che le informazioni rivelate possano essere scambiate con le autorità fiscali del/i paese/i in cui io/noi e/o l\'Investitore ha/hanno stabilito una residenza fiscale in conformità con gli accordi intergovernativi di scambio di dati fiscali.',
        tax_data_exchange_agreement:
            'Io/noi autorizziamo VV a inoltrare/scambiare tutte le informazioni rivelate, nonché le informazioni necessarie per la segnalazione ai sensi degli accordi intergovernativi di scambio di dati fiscali, come descritto sopra, con le competenti autorità fiscali del paese o dei paesi.',
        report_changes:
            'Io/noi ci impegniamo a notificare a VV entro 30 giorni qualsiasi modifica che influisca sull`autocertificazione e qualsiasi modifica che influisca sulle informazioni fornite e a fornire a VV una corrispondente autocertificazione aggiornata senza indugio e senza richiesta. Io/noi avranno accesso, su richiesta, ai dati che mi/ci riguardano/l`Investitore/gli UBO che saranno rivelati alle autorità fiscali lussemburghesi e potranno rettificare i dati personali. I dati raccolti non saranno conservati più a lungo del necessario per gli scopi della legge CRS del Lussemburgo.',
        complete_and_correct_information:
            'Io/noi dichiariamo che tutte le informazioni fornite da me/noi sono corrette e complete secondo la mia/nostra migliore conoscenza e convinzione.',
    },
    experience_and_knowledge: {
        experience: 'Esperienza di investimento',
        knowledge: 'Conoscenza',
        stocks_equity_funds: 'Azioni, fondi azionari',
        mixed_funds_etfs: 'Fondi misti, ETF',
        bonds_bond_funds: 'Obbligazioni, fondi obbligazionari',
        closed_ended_funds: 'Fondi chiusi',
        options_other_derivatives: 'Opzioni, altri derivati',
        venture_capital: 'Venture capital',
        other_shares_loans_in_private_companies: 'Altre azioni/prestiti in società private',
        other_alternative_investments: 'Altri investimenti alternativi (hedge fund, fondi merce, ecc.)',
        follow_market_prices_business_financial_news:
            'Con quale frequenza controlli i prezzi di mercato, le notizie aziendali e finanziarie?',
    },
    follow_market_options: {
        regularly: 'regolarmente',
        occasionally: 'occasionalmente',
        rarely: 'raramente',
        not_at_all: 'per niente',
    },
    investment_knowledge: {
        advanced: 'avanzato',
        basic: 'base',
        none: 'nessuno',
    },
    investment_horizon: {
        short_term: 'breve termine (< 5 anni)',
        medium_term: 'medio termine (5-10 anni)',
        long_term: 'lungo termine (11-20 anni)',
        very_long_term: 'molto lungo termine (> 20 anni)',
    },
    investment_frequency: {
        one_off: 'una tantum',
        monthly: 'mensile',
        quarterly: 'trimestrale',
        semi_annually: 'semestrale',
        annually: 'annuale',
    },
    risk_tolerance: {
        label: 'La tua tolleranza al rischio è:',
        // prettier-ignore
        label_legal: 'Tolleranza al rischio dell\'Investitore (Entità legale):',
        low: 'Bassa',
        medium: 'Media',
        advanced: 'Avanzata',
        high: 'Alta',
    },
    verification: {
        identity_verification: 'Verifica dell`identità',
        identity_verification_subheadline: 'Sottotitolo verifica identità',
        identity_verification_upload_notice: 'Avviso caricamento verifica identità',
        tax_verification: 'Verifica fiscale',
        bank_verification: 'Verifica bancaria',
        bank_verification_headline: 'Titolo verifica bancaria',
        address_verification: 'Verifica indirizzo',
        address_verification_headline: 'Titolo verifica indirizzo',
        address_verification_subheadline: 'Sottotitolo verifica indirizzo',
        legal_verification: 'Verifica legale',
        legal_verification_subheadline: 'Sottotitolo verifica legale',
        legal_bank_verification: 'Verifica bancaria legale',
        legal_bank_verification_subheadline: 'Sottotitolo verifica bancaria legale',
        upload_label: 'Etichetta caricamento',
        upload_invalid_field: 'Campo caricamento non valido',
        upload_waiting_for_size: 'In attesa della dimensione del caricamento',
        upload_size_not_available: 'Dimensione caricamento non disponibile',
        upload_loading: 'Caricamento in corso',
        upload_load_error: 'Errore di caricamento',
        upload_processing: 'Elaborazione caricamento',
        upload_processing_complete: 'Elaborazione caricamento completata',
        upload_processing_aborted: 'Elaborazione caricamento interrotta',
        upload_processing_error: 'Errore elaborazione caricamento',
        upload_processing_revert_error: 'Errore ripristino elaborazione caricamento',
        upload_file_remove_error: 'Errore rimozione file caricamento',
        upload_tap_to_cancel: 'Tocca per annullare',
        upload_tap_to_retry: 'Tocca per riprovare',
        upload_tap_to_undo: 'Tocca per annullare',
        upload_button_remove_item: 'Rimuovi elemento',
        upload_button_abort_item_load: 'Interrompi caricamento elemento',
        upload_button_retry_item_load: 'Riprova caricamento elemento',
        upload_button_abort_item_processing: 'Interrompi elaborazione elemento',
        upload_button_undo_item_processing: 'Annulla elaborazione elemento',
        upload_button_retry_item_processing: 'Riprova elaborazione elemento',
        upload_button_process_item: 'Elabora elemento',
        tax_verification_headline: 'Titolo verifica fiscale',
        complete_data: 'Completa dati',
        complete_data_description: 'Descrizione completamento dati',
        complete_data_description_for_verification: 'Descrizione completamento dati per verifica',
        complete_data_description_short: 'Descrizione breve completamento dati',
        complete_verification_outstanding: 'Verifica incompleta',
        complete_verification_complete: 'Verifica completata',
        completed_data: 'Dati completati',
        completed_data_description: 'Descrizione dati completati',
        complete_data_action_button: 'Pulsante azione completamento dati',
        kyc_process: 'Processo KYC',
        kyc_process_description: 'Descrizione processo KYC',
        kyc_process_action_button: 'Pulsante azione processo KYC',
        old_value: 'Vecchio valore',
        no_changes: 'Tutti i dati corrispondono alle informazioni fornite in precedenza.',
        save: 'Salva',
        new_value: 'Nuovo valore',
        override_data: 'Sovrascrivi dati',
        override_data_description: 'Descrizione sovrascrittura dati',
        verification_successful: 'Verifica completata con successo',
        verification_successful_description: 'Descrizione verifica completata con successo',
        status_not_started: 'Stato non iniziato',
        status_not_started_description: 'Descrizione stato non iniziato',
        status_created: 'Stato creato',
        status_created_description: 'Descrizione stato creato',
        status_in_review: 'Stato in revisione',
        status_in_review_description: 'Descrizione stato in revisione',
        status_data_changed: 'Stato dati modificati',
        status_data_changed_description: 'Descrizione stato dati modificati',
        status_success: 'Stato successo',
        status_success_description: 'Descrizione stato successo',
        status_failure: 'Stato fallimento',
        status_failure_description: 'Descrizione stato fallimento',
        id_now_kyc_continue_button: 'Pulsante continua KYC IDNow',
        id_now_kyc_waiting_for_id_now_button: 'Pulsante in attesa IDNow KYC',
        id_now_kyc_restart_button: 'Pulsante riavvia KYC IDNow',
        id_now_kyc_start_button: 'Pulsante avvia KYC IDNow',
        ecsp_status_rejected: 'Non qualificato - rifiutato',
        ecsp_status_pending: 'Non qualificato - verifica in sospeso',
        ecsp_status_expert: 'Qualificato',
        ecsp_status_non_expert: 'Non qualificato',
        signteq_kyc_start_button: 'Avvia verifica KYC',
        signteq_kyc_restart_button: 'Riavvia processo KYC',
    },
    camera: {
        click_here_to_capture_image: 'Clicca qui per scattare una foto',
        close: 'Chiudi fotocamera',
        or: 'o',
    },
    id_front: 'Fronte',
    id_back: 'Retro',
    newsletter_verification_success: 'La tua iscrizione alla newsletter è stata confermata con successo!',
    membership_document: {
        status: {
            accepted: 'Accettato',
            pending: 'In attesa',
            rejected: 'Rifiutato',
        },
    },
    ecsp: {
        natural: {
            info_text: '',
            info_text_highlight_one: '',
            info_text_highlight_two: '',
            info_text_highlight_three: '',
            info_text_link_placeholder: '',
            investor_classification: {
                expert_investor_explanation: '',
            },
            experience: {
                no_answer: '',
                financial_education: '',
                bonds_knowledge: '',
                bonds_investment_frequency: '',
                stocks_knowledge: '',
                stocks_investment_frequency: '',
                convertible_bonds_knowledge: '',
                convertible_bonds_investment_frequency: '',
            },
            risk: {
                no_answer: '',
                startup_investing: '',
                investments_outside_stock_market: '',
                subordinated_financial_instruments: '',
                profit_participation_certificate: '',
            },
        },
        legal: {
            info_text: '',
            info_text_link_placeholder: '',
            investor_classification: {
                expert_investor_explanation: '',
            },
            risk: {
                most_startups: '',
                dividends: '',
                higher_interest_rates: '',
                secure_investment: '',
                stocks_bankrupt_company: '',
                good_long_term_investment: '',
                return_on_investment: '',
            },
        },
        investment_frequency: {
            less_than_5_times: 'Meno di 5 volte',
            more_than_5_times: 'Più di 5 volte',
            no_answer: 'Nessuna risposta',
        },
        investment_horizon: {
            two_years: 'Due anni',
            up_to_5_years: 'Fino a 5 anni',
            more_than_5_years: 'Più di 5 anni',
            no_answer: 'Nessuna risposta',
        },
        startup_investing: {
            high_return_low_risk: 'Alto rendimento, basso rischio',
            loss: 'Perdita',
            growth: 'Crescita',
        },
        investments_outside_stock_market: {
            low_risk: 'Basso rischio',
            high_risk: 'Alto rischio',
            high_proportion: 'Alta proporzione',
        },
        subordinated_financial_instruments: {
            insolvency_quote: 'Quota di insolvenza',
            equal_with_other_creditors: 'Uguale agli altri creditori',
            lose_investment: 'Perdita dell`investimento',
        },
        profit_participation_certificate: {
            participate_profits_losses: 'Partecipazione a profitti e perdite',
            fixed_interest_amount: 'Importo fisso degli interessi',
            transfer_to_company: 'Trasferimento all`azienda',
        },
        investor_classification: {
            expert_investor_treatment: 'Trattamento dell`investitore esperto',
            self_disclosure_explanation: 'Spiegazione dell`autodichiarazione',
            self_disclosure: 'Autodichiarazione',
            print: 'Stampa',
            upload_self_disclosure: 'Carica autodichiarazione',
        },
        financial_education: {
            professional_experience: 'Esperienza professionale',
            relevant_degree: 'Laurea pertinente',
            both: 'Entrambi',
            none: 'Nessuno',
        },
        investment_goals: {
            no_answer: 'Nessuna risposta',
            sustainability: 'Sostenibilità',
            investment_goal: 'Obiettivo di investimento',
            investment_horizon: 'Orizzonte di investimento',
        },
        sustainability: {
            very_true: 'Molto vero',
            applies: 'Si applica',
            does_not_apply: 'Non si applica',
            no_answer: 'Nessuna risposta',
        },
        investment_goal: {
            wealth_building: 'Costruzione di ricchezza',
            speculative_investments: 'Investimenti speculativi',
            no_answer: 'Nessuna risposta',
        },
        most_startups: {
            successful: 'Di successo',
            fail: 'Falliscono',
        },
        dividends: {
            equity: 'Capitale proprio',
            debt_capital: 'Capitale di debito',
        },
        higher_interest_rates: {
            secure_investment: 'Investimento sicuro',
            risk_investment: 'Investimento rischioso',
        },
        secure_investment: {
            bond_brd: 'Obbligazione BRD',
            bond_us_treasury: 'Obbligazione del Tesoro USA',
            vw_share: 'Azione VW',
        },
        stocks_bankrupt_company: {
            refund: 'Rimborso',
            loss: 'Perdita',
        },
        good_long_term_investment: {
            company_investment_portfolio: 'Portafoglio di investimenti aziendali',
            scatter_investments: 'Dispersione degli investimenti',
        },
        return_on_investment: {
            less_than_5_years: 'Meno di 5 anni',
            more_than_5_years: 'Più di 5 anni',
        },
        financial_situation: {
            calculate: 'Calcola',
            no_value: 'N/A',
            net_worth: 'Patrimonio netto',
            net_worth_tooltip: 'Il tuo patrimonio netto totale',
            loss_bearing_capacity: 'Capacità di sopportare perdite',
            loss_bearing_capacity_tooltip: 'La tua capacità di sopportare perdite finanziarie',
            annual_net_income: 'Reddito netto annuale',
            annual_net_income_tooltip: 'Il tuo reddito netto annuale',
            annual_financial_commitments: 'Impegni finanziari annuali',
            annual_financial_commitments_tooltip: 'I tuoi impegni finanziari annuali',
            calculation_of_net_worth: 'Calcolo del patrimonio netto',
            liquid_funds: 'Fondi liquidi',
            liquid_funds_tooltip: 'I tuoi fondi liquidi disponibili',
            info_text: 'Testo informativo',
        },
    },
    legal_account: {
        company_profile: 'Profilo aziendale',
        company_name: 'Nome azienda',
        registration_number: 'Numero di registrazione',
        legal_form: 'Forma giuridica',
        registration_authority: 'Autorità di registrazione',
        address: 'Indirizzo',
        description: 'Descrizione',
        postal_code: 'Codice postale',
        city: 'Città',
        state: 'Stato',
        country: 'Paese',
        iban: 'IBAN',
        bic: 'BIC',
        tax_number: 'Numero fiscale',
        saved_successfully_title: 'Salvato con successo',
        saved_successfully_message: 'I dati sono stati salvati con successo',
        investor_classification: 'Classificazione dell`investitore',
        risk: 'Rischio',
        financial_situation: 'Situazione finanziaria',
        default_language: 'Lingua predefinita',
    },
    beneficial_owner: {
        country_of_birth: 'Paese di nascita',
        city_of_birth: 'Città di nascita',
        country_of_residence: 'Paese di residenza',
        no_beneficial_owners: 'Nessun beneficiario effettivo',
        no_beneficial_owners_description: 'Non ci sono beneficiari effettivi da mostrare',
        indirect_ownership: 'Indicare il nome della rispettiva società in caso di proprietà indiretta',
        remove: 'Rimuovi',
    },
    highest_educational_attainment: {
        prefer_not_to_say: 'Preferisco non dirlo',
        no_degree: 'Nessun titolo',
        secondary_school: 'Scuola secondaria',
        junior_high_school: 'Scuola media',
        high_school_diploma: 'Diploma di scuola superiore',
        university: 'Università',
    },
    investment_experience: {
        none: 'Nessuna',
        up_to_3_years: 'Fino a 3 anni',
        between_3_and_5_years: 'Tra 3 e 5 anni',
        more_than_5_years: 'Più di 5 anni',
    },
    average_investment_transaction: {
        none: 'Nessuna',
        up_to_5: 'Fino a 5',
        between_5_and_10: 'Tra 5 e 10',
        over_10: 'Oltre 10',
    },
    average_investment_amount: {
        up_to_3000_eur: 'Fino a 3000 EUR',
        between_3001_and_5000_eur: 'Tra 3001 e 5000 EUR',
        between_5001_and_10000_eur: 'Tra 5001 e 10000 EUR',
        over_10000_eur: 'Oltre 10000 EUR',
    },
    validation_error: {
        required: 'Campo obbligatorio',
        email: 'Email non valida',
        invalid: 'Valore non valido',
        countryISO3166: 'Paese non valido',
        iban: 'IBAN non valido',
        bic: 'BIC non valido',
        new_email_not_equals_old: 'La nuova email non può essere uguale alla vecchia',
        wrong_date_format: 'Formato data non valido',
        date_min: 'Data minima non valida',
        date_max: 'Data massima non valida',
        min_age: 'Età minima non valida',
        max_age: 'Età massima non valida',
        min_amount: 'Importo minimo non valido',
        min_amount_on_wallet: 'Importo minimo nel portafoglio non valido',
        max_amount: 'Importo massimo non valido',
    },
    account_settings: {
        dashboard: 'Dashboard',
        personal_data: 'Dati personali',
        personal_data_headline: 'I tuoi dati personali',
        address_data: 'Dati indirizzo',
        address_data_headline: 'Il tuo indirizzo',
        address_data_subtitle: 'Gestisci il tuo indirizzo',
        membership_management: 'Gestione appartenenza',
        nyala_vault: 'Nyala Vault',
        nyala_vault_headline: 'Nyala Vault',
        nyala_vault_subtitle: 'Gestisci il tuo Nyala Vault',
        postal_address_data: 'Il tuo indirizzo postale',
        compliance_profile: 'Profilo di conformità',
        compliance_profile_subtitle: 'Gestisci il tuo profilo di conformità',
        contact_data: 'Dati di contatto',
        contact_data_headline: 'I tuoi dati di contatto',
        contact_data_subtitle: 'Gestisci i tuoi dati di contatto',
        security: 'Sicurezza',
        security_headline: 'Sicurezza',
        security_subtitle: 'Gestisci la tua sicurezza',
        verification: 'Verifica',
        verification_headline: 'Verifica',
        verification_subtitle: 'Gestisci la tua verifica',
        bank_data: 'Dati bancari',
        bank_data_headline: 'I tuoi dati bancari',
        bank_data_subtitle: 'Gestisci i tuoi dati bancari',
        tax_residencies: 'Residenze fiscali',
        tax_data: 'Dati fiscali',
        overview: 'Panoramica',
        profile_data: 'Dati profilo',
        legal_information: 'Informazioni legali',
        edit: 'Modifica',
        legal_information_subtitle: 'Gestisci le tue informazioni legali',
        current_status: 'Stato attuale',
        crypto_wallet: 'Portafoglio crypto',
        crypto_wallet_headline: 'Portafoglio crypto',
        signatures: 'Firme',
        signatures_headline: 'Firme',
        signatures_subtitle: 'Gestisci le tue firme',
        referral_program: 'Programma referral',
        referral_program_headline: 'Programma referral',
        referral_program_notice: 'Avviso programma referral',
        investment_targets: 'Profilo investitore',
        investment_targets_subtitle:
            'L`orizzonte di investimento rappresenta la tua disponibilità di base alla durata dell`investimento.',
        financial_conditions: 'Posizione finanziaria',
        experience_and_knowledge: 'Esperienza e conoscenza degli investimenti',
        risk_tolerance: 'Tolleranza al rischio',
        fatca_declaration: 'Dichiarazione FATCA',
        acknowledgements: 'Dichiarazioni',
        kyc_form: 'Modulo KYC',
        tax_situation: 'Situazione fiscale',
        investor_classification: 'Classificazione dell`investitore',
        experience: 'Esperienza',
        risk: 'Rischio',
        investment_goals: 'Obiettivi di investimento',
        financial_situation: 'Situazione finanziaria',
    },
    compliance_profile: {
        save_header: 'Salva',
        save_description: 'Salva le modifiche',
        discard_header: 'Annulla',
        discard_description: 'Annulla le modifiche',
        save_financial_data_header: 'Salva dati finanziari',
        save_financial_data_description: 'Salva i tuoi dati finanziari',
        back_to_compliance_profile: 'Torna al profilo di conformità',
        status: 'Stato: {status}',
        compliance_profile_complete_and_valid_description: 'Il tuo profilo di conformità è completo e valido.',
        compliance_profile_complete_and_invalid_description: 'Il tuo profilo di conformità è completo ma non valido.',
        compliance_profile_incomplete_description: 'Il tuo profilo di conformità è incompleto.',
        complete: 'Completo',
        incomplete: 'Incompleto',
        complete_data: 'Completa il profilo di conformità',
        complete_data_description: 'Completa i dati nel tuo profilo di conformità per continuare.',
        show_document: 'Mostra documento',
        upload_document: 'Carica nuovo documento',
        edit_data: 'Modifica dati',
        discard_data: 'Annulla dati',
    },
    signatures: {
        complete_data_description_for_signatures: 'Completa i dati per le firme',
        complete_compliance_profile: 'Completa il profilo di conformità',
        sign_document: 'Firma documento',
        sign_documents: 'Firma documenti',
        not_signed: 'Non firmato',
        signed: 'Firmato',
        no_signatures: 'Nessuna firma',
        no_signatures_description: 'Non ci sono firme da mostrare',
        pending_signatures: 'Firme in sospeso',
        pending_signatures_description: 'Ci sono firme in attesa di essere completate',
        show_document: 'Mostra documento',
        dialog_close_button: 'Chiudi',
        regenerate_signatures: 'Rigenera firme',
        regenerate_signatures_notice: 'Avviso rigenerazione firme',
        print: 'Stampa',
    },
    account_settings_legal: {
        dashboard: '',
        company_data: '',
        overview: '',
        address_data: '',
        bank_data: '',
        tax_data: '',
        verification: '',
        verification_kyc_documents_subtitle: '',
        manager_area: '',
        manager_area_subtitle: '',
        beneficial_owners: '',
        beneficial_owners_subtitle: '',
        investment_objectives: 'Profilo di investimento dell`entità',
        financial_conditions: 'Posizione finanziaria dell`entità',
        risk_tolerance: 'Tolleranza al rischio dell`entità',
        tax_situation: 'Informazioni fiscali',
        crs_classification: 'Classificazione CRS',
        // prettier-ignore
        legal_entity_investment_profile:
            'È importante che conosciamo l\'atteggiamento generale dell\'Investitore verso il tipo di investimento, la sua disposizione al rischio, la capacità di sopportare il rischio e la conoscenza del rischio. Ti chiediamo quindi di completare onestamente questa sezione per l\'Investitore.',
        legal_entity_financial_position:
            'Completa queste informazioni sulla posizione finanziaria dell`entità. Questo serve a comprendere la capacità dell`entità di sopportare il rischio in relazione alla sua ricchezza finanziaria netta approssimativa.',
        legal_manager_one_experience_and_knowledge:
            'Indica la tua esperienza personale e la conoscenza delle classi di asset indicate, nonché dei mercati finanziari. Completa questo personalmente come AD (e non per l`Entità legale investitrice).',
        legal_manager_two_experience_and_knowledge:
            'Indica l`esperienza personale dell`AD 2 e la conoscenza delle classi di asset indicate, nonché dei mercati finanziari.',
        legal_manager_two_authorization:
            'Completa l`Esperienza e la Conoscenza degli Investimenti dell`AD 2, con la sua approvazione. Questo sarà incluso in un modulo KYC che sarà firmato da entrambi i manager.',
        legal_entity_fatca:
            'Le informazioni in questa sezione sono per scopi FATCA. Nota che questa classificazione potrebbe differire dalla tua classificazione CRS.',
        legal_entity_tax_situation: 'Conferma la situazione fiscale dell`Entità e i paesi di cui è residente fiscale.',
        legal_entity_crs: 'Seleziona la classificazione CRS dell`Entità:',
        legal_acknowledgements:
            'Leggi attentamente e conferma le dichiarazioni fornite. Queste saranno firmate elettronicamente sui moduli KYC.',
        legal_beneficial_owner: 'Completa le Informazioni Personali del rispettivo beneficiario effettivo.',
        legal_kyc_form:
            'Grazie per aver completato la procedura guidata KYC! Il modulo "ESAC entità legale" include tutte le informazioni e le dichiarazioni che hai appena fornito. Rivedi attentamente il modulo e firmalo elettronicamente. Se hai un secondo firmatario richiesto (AD 2), anche lui/lei deve firmare questo modulo. Il/i documento/i parzialmente precompilato/i "ESAC Legal UBO for ..." deve/ono essere completato/i e firmato/i dal/i rispettivo/i Beneficiario/i effettivo/i. Il/i documento/i completato/i e firmato/i deve/ono essere caricato/i nella pagina dell\'account aziendale sulla piattaforma (seleziona il tuo profilo nell\'angolo in alto a destra, quindi account aziendale e Firme in basso a sinistra). \n' +
            'I moduli e la documentazione saranno quindi esaminati da Venionaire Ventures e, una volta approvati, riceverai una notifica e potrai accedere a tutti gli Affari di Investimento sulla piattaforma. Ti contatteremo se abbiamo domande sul tuo modulo o sui tuoi documenti.',
    },
    security: {
        password: {
            title: '',
            hint: '',
            update: '',
        },
        two_factor_authentication: {
            title: '',
            hint: '',
            configure: '',
            list_title: '',
            type: '',
            types: {
                otp: '',
                sms: '',
                passkey: '',
            },
            user_label: '',
            date: '',
            action: '',
            remove: '',
            non_removeable: '',
            remove_success: '',
        },
        dialogs: {
            error_title: '',
            error_message: '',
            success_title: '',
            success_message: '',
        },
        external_security_link: {
            title: '',
            hint: '',
            redirect: '',
        },
    },
    dialog: {
        button: {
            confirm: '',
            cancel: '',
            back: '',
            close: '',
            ok: '',
        },
        formDirty: {
            title: '',
            text: '',
            confirm: '',
            cancel: '',
        },
        formInvalid: {
            title: '',
            text: '',
        },
        iframe_link_notice: '',
        iframe_link_notice_link: '',
    },
    yes_no_deny: {
        yes: '',
        no: '',
        no_answer: '',
    },
}
